import { render } from "./super-admin-permissions.vue?vue&type=template&id=b0b0b6d0"
import script from "./super-admin-permissions.vue?vue&type=script&lang=js"
export * from "./super-admin-permissions.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/applications/admin/super-admin-permissions.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b0b0b6d0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b0b0b6d0', __exports__)) {
    api.reload('b0b0b6d0', __exports__)
  }
  
  module.hot.accept("./super-admin-permissions.vue?vue&type=template&id=b0b0b6d0", () => {
    api.rerender('b0b0b6d0', render)
  })

}


export default __exports__